<template>
	<FormField :label="label">
		<Combobox
			v-model="usersModel"
			:options="allUsers || []"
			optionLabel="name"
			optionValue="id"
			sort
			:multiple="!props.single"
			virtual
		>
			<template #selection="{ option }">
				<Badge close @click:close="removeUser(option.id)">
					{{ option.name }}
				</Badge>
			</template>
		</Combobox>
	</FormField>
</template>

<script setup lang="ts">
import { useUsers } from "@/api/user-query";
import { Badge, Combobox, FormField } from "@soft-db/ui";
import { useVModel } from "@vueuse/core";
import { PropType } from "vue";

const props = defineProps({
	label: String,
	users: {
		type: [Array, String] as PropType<string[] | string>,
	},
	hideDetails: Boolean,
	single: Boolean,
});

const usersModel = useVModel(props, "users");

const { data: allUsers } = useUsers();

const removeUser = (id: string) => {
	if (!Array.isArray(usersModel.value)) {
		usersModel.value = undefined;
	} else {
		usersModel.value = usersModel.value.filter((user) => user !== id);
	}
};
</script>
